import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const cn = (...classes: ClassValue[]) => twMerge(clsx(classes));
export * from './CustomNavigationClient';
export * from './isValidPhoneNum';
export * from './isValidPostcode';
export * from './AddressInputUtils';
export * from './mapUtils';
export * from './uploadPhotos';
export * from './Holidays';
export * from './testUtils/TestUtils';
export * from './validations/validations';
export * from './validations/errorFormatter';
export * from './ProtectedRoute/ProtectedRoute';
export * from './authConfig/authConfig';
export * from './fetchToken/fetchToken';
export * from './msalConfig/msalConfig';
export * from './domUtils/scrollIntoView';
export * from './renderRadioButton';
export * from './analytics';
